import type { SVGProps } from 'react';

export const File = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.3 21.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 4.5 19.7V4.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h7.2c.25 0 .483.05.7.15.217.083.408.208.575.375l4.2 4.2c.167.167.292.358.375.575.1.217.15.45.15.7v11.2c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H6.3Zm7.2-13.9V4H6.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v15.4c0 .067.033.133.1.2s.133.1.2.1h11.4c.067 0 .133-.033.2-.1s.1-.133.1-.2V8.5h-3.6a.934.934 0 0 1-.65-.25.934.934 0 0 1-.25-.65ZM6 4v4.5V4v16V4Z" />
    </svg>
  );
};
